/*
 *   File : phone-input.js
 *   Author : https://evoqins.com
 *   Description : Phone input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';

//custom style
import style from "../../Styles/Component/input.module.scss";
import { Icon } from '../Icon';

const CustomPhoneInput = (props) => {

    const [isInputFocused, setIsInputFocused] = useState(false);

    // handle focus 
    const _handleFocus = () => {
        setIsInputFocused(true);
    };

    const _handleBlur = () => {
        setIsInputFocused(false);
    };

    //input handle change
    const _handleChange = (e) => {
        let value = e.target.value;
        props.handleChange(value);
    };

    // handle enter key press
    const keyPress = (e) => {
        if (e.keyCode === 13) {
            props.onKeyPress();
        }
    };

    const _handleKeyDown = (e) => {
        // Prevent default behavior of up and down arrow keys
        if (e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
        }

        if (e.key === 'e' || e.keyCode === 69) {
            e.preventDefault();
        }

        if (props.type === "number") {
            if (e.key === '0' && props.value === '') {
                e.preventDefault();
            }
        }
        if (e.key === '.' && props.not_decimal) {
            e.preventDefault();
        }
    };


    return (
        <div className={props.wrapperClass} ref={props.ref} >
            {props.label &&
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-alt-font-lato e-font-weight-400 line-height-20px padding-8px-bottom`}>
                    {props.label}
                    {props.require &&
                        <span className='e-text-vermilion'>*</span>
                    }
                </label>
            }

            <div className={`${style.e_input_wrapper} position-relative`}>
                <div className={` ${props.error && style.e_error_border} ${isInputFocused ? `${style.e_active} ` : `${style.e_inactive} ${props.borderStyle}`} border-radius-8 d-flex align-items-center px-2 px-sm-3 gap-2`}>

                    <p className={`${props.value ? "e-font-weight-600" : "e-font-weight-400"} mb-0 e-alt-font-lato e-font-14 e-text-chinese-black line-height-18px cursor-default`}>
                        +91
                    </p>
                    <span className='e-text-light-periwinkle vr h-24 my-auto' />

                    <input id={props.id}
                        ref={props.ref}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type="number"
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${style.e_input} ${props.className} ${props.padding ? props.padding : "py-2 py-sm-3"} border-0 border-radius-8 e-bg-white e-font-14 e-text-chinese-black e-font-weight-600 line-height-18px e-alt-font-lato`}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        onKeyDown={(e) => {
                            keyPress(e);
                            _handleKeyDown(e);
                        }}
                        onClick={props.onClick} />

                </div>
                {
                    props.edit &&
                    <Icon icon="edit"
                        size="16px"
                        className="cursor-pointer position-absolute top-50 end-0 translate-middle-y me-3"
                        onClick={props.onEdit} />
                }

                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-vermilion e-alt-font-lato e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div >
    )
}

CustomPhoneInput.defaultProps = {
    onKeyPress: () => { },
    className: null,
    error: "",
    value: "",
}

export default memo(CustomPhoneInput);